<template>
  <v-container fluid>
    <v-toolbar dark prominent src="@/assets/img/topbar4.png">
      <v-toolbar-title>
        <v-img src="@/assets/img/Logo_97x23.png"></v-img>
      </v-toolbar-title>
      <v-spacer />
     <h2> Calendar {{ schoolYear.name }}</h2> 
    </v-toolbar>
    
    <v-row>
     <v-col>
       <v-card max-width="800" class="mx-auto mt-3" outlined elevation="10">
         <v-toolbar dark color="primary">
           <v-spacer />
           <h3> Select Calendar:</h3> 
        <v-select
          class="mt-3 ml-10"
          v-model="location_id"
          :items="locations"
          item-text="name"
          item-value="id"
          
          dense
          dark
        ></v-select>
      
    
          </v-toolbar>
         <v-card-text>
          <v-row>
            <v-col class="justify-center">
        <vc-calendar
        
          class="mt-4"
         
          :rows="1"
              :columns="
                $vuetify.breakpoint.width > 1200
                  ? 3
                  : $vuetify.breakpoint.width > 600
                  ? 2
                  : 1
              "
          :attributes="attributes"
          :from-date="calendarStart"
          is-range
          
        >
        </vc-calendar>
        </v-col>
        <v-col>
 <v-data-table
 
            dense
              :headers="headers"
              :items="eventTable"
              :items-per-page="100"
              class="elevation-5 mt-5 mx-auto"
            >
            <template v-slot:header.name="{ header }">
      {{ header.text.toUpperCase() }}
    </template>
     <template v-slot:header.start_date="{ header }">
      {{ header.text.toUpperCase() }}
    </template>
     <template v-slot:header.end_date="{ header }">
      {{ header.text.toUpperCase() }}
    </template>
              <template v-slot:[`item.location_id`]="{ item }">
                {{ item.location_id == 6 ? "District" : locationName }}
              </template>
              <template v-slot:[`item.start_date`]="{ item }">
                {{ new Date(item.start_date).toLocaleDateString('en-US', {month: 'short', day: 'numeric' }) }}
              </template>
              <template v-slot:[`item.end_date`]="{ item }">
                {{ new Date(item.end_date).toLocaleDateString('en-US', {month: 'short', day: 'numeric' }) }}
              </template>
             
            </v-data-table>
            </v-col>
</v-row>
        </v-card-text>
        </v-card>
     </v-col>
    </v-row>
   
    <v-snackbar v-model="snackbar">
      Click on events or grading periods to see on calendar
    </v-snackbar>
  </v-container>
</template>
<script>
import Vue from "vue";
import VCalendar from "v-calendar";

Vue.use(VCalendar, {
  componentPrefix: "vc",
});

export default {
  data: () => ({
    snackbar: true,
    
    location_id: 6,
    locations: [],
    schoolYear: {},
    modelConfig: {
      start: {
        timeAdjust: "12:00:00",
      },
      end: {
        timeAdjust: "12:00:00",
      },
    },
    calendarItems: [],
    types: [],
    headers: [
      { text: "Event", value: "name" },
      { text: "Start Date", value: "start_date" },
      { text: "End Date", value: "end_date" },
      // { text: "Type", value: "type" },
       { text: "Calendar", value: "location_id" },
    ],
    
  }),
  computed: {
    calendarStart() {
      return new Date();
    },
    
    locationName() {
      return this.locations
        .filter((location) => location.id == this.location_id)
        .map((l) => l.name)
        .join(",");
    },
    eventTable() {
      return this.items.filter((item) => !(item.type == "grading-period"));
    },

    items() {
      let currentTableItems = [];
      if (this.calendarItems[this.location_id] && this.calendarItems[6]) {
        if (this.location_id == 6) {
          currentTableItems = [...this.calendarItems[6]];
        } else {
          currentTableItems = [
            ...this.calendarItems[6],
            ...this.calendarItems[this.location_id],
          ];
        }
      } else if (this.calendarItems[this.location_id]) {
        currentTableItems = [...this.calendarItems[this.location_id]];
      } else if (this.calendarItems[6]) {
        currentTableItems = [...this.calendarItems[6]];
      }
      return currentTableItems
        .filter(
          (item) =>
            Number(item.school_year) == Number(this.schoolYear.school_year)
        )
        .sort(function (a, b) {
          return new Date(a.start_date) - new Date(b.start_date);
        });
    },
    attributes() {
      return [
      ...this.items.map((item) => ({
        //key: item.id,
        dates: { start: item.start_date, end: item.end_date },
        popover: {label: item.name,},
       // dots: true,
        highlight: {
          start: { fillMode: "solid", color: this.getColor(item) },
          base: { fillMode: "light", color: this.getColor(item) },
          end: { fillMode: "solid", color: this.getColor(item) },
        },
        customData: item,
      }))
      ]
    },
  },
  methods: {
    /* addRemoveAttribute(item) {
      let ind = this.attributes.findIndex((att) => att.key == item.id);
      if (ind > -1) {
        this.attributes.splice(ind, 1);
        return;
      }
      this.attributes.push({
        key: item.id,
        dates: { start: item.start_date, end: item.end_date },
        popover: {
          label: item.name + "(" + item.type + ")",
          visibility: "focus",
        },
        dots: true,
        highlight: {
          start: { fillMode: "solid", color: this.getColor(item) },
          base: { fillMode: "light", color: this.getColor(item) },
          end: { fillMode: "solid", color: this.getColor(item) },
        },
        customData: item,
      });
    }, */
    getColor(item) {
      if (item.type == "no-students-and-staff") {
        return "red";
      } else if (item.type == "grading-period") {
        return "green";
      } else if (item.type == "no-students") {
        return "purple";
      }
      return "blue";
    },
  },
  mounted() {
      this.locations= [ 
        { "id": 4, "entity_id": null, "name": "BuffSci Elementary", "schedule_cycle_days": 2 }, 
      { "id": 3, "entity_id": null, "name": "BuffSci Middle", "schedule_cycle_days": 2 }, 
       { "id": 1, "entity_id": null, "name": "BuffSci High", "schedule_cycle_days": 2 }, 
      { "id": 7, "entity_id": null, "name": "BuffSci 2- Elementary", "schedule_cycle_days": 2 }, 
      { "id": 8, "entity_id": null, "name": "BuffSci 2- High", "schedule_cycle_days": 2 },
       { "id": 6, "entity_id": null, "name": "District Calendar", "schedule_cycle_days": 2 }, 
      ]
/* 
    this.$sisApi("get", `web-calendar/locations`)
      .then((response) => {
        this.locations = response.data;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          console.log(error.response);
        }
      });
 */

    this.$sisApi("get", `web-calendar/locations/school-years`)
      .then((response) => {
        this.schoolYear = response.data.current_year;
      })
      .catch((error) => {
        console.log(error);
        this.snackbar = true;
        this.snackbar_text = error.response.data.message;
      });
    this.$sisApi("get", "web-calendar/calendar-items")
      .then((response) => {
        this.calendarItems = response.data;
      })
      .catch((error) => {
        console.log(error);
        this.snackbar = true;
        this.snackbar_text = error.response.data.message;
      });
    this.$sisApi("get", "web-calendar/calendar-items/get-types")
      .then((response) => {
        this.types = response.data;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          console.log(error);
          this.snackbar = true;
          this.snackbar_text = error.response.data.message;
        }
      });
  },
};
</script>
